import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eead70c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "micro-row table-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Name"),
  /*#__PURE__*/_createElementVNode("span", null, "µGlyph"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", null, "Text description"),
  /*#__PURE__*/_createElementVNode("span", null, "Image description")
], -1))
const _hoisted_2 = { class: "table-body" }

import MicroRow from '@/components/Table/MicroRow'
import SearchBar from '@/components/Table/SearchBar'
import { inject, onMounted, ref, watch } from 'vue'

export default {
  __name: 'TableView',
  setup(__props) {

const { Action, Context } = require('@/components/Microgesture/struct')

const axios = inject('axios')

const allMM = ref([])
const displayedMM = ref([])
const reloadTable = ref(0)
const microgesteSearchValue = ref(undefined)

const copiedMicrogesture = ref(undefined)

watch(copiedMicrogesture, () => {
  this.microgesteSearchValue = this.copiedMicrogesture
})

// eslint-disable-next-line no-unused-vars
function sortMicrogeste (m1, m2) {
  if (m1.type !== m2.type) {
    const type = ['glyph', 'then', 'or', 'and', 'seq', 'in-construction']
    const i1 = type.indexOf(m1.type)
    const i2 = type.indexOf(m2.type)
    if (i1 !== i2) return (i1 > i2) ? 1 : -1
    else return 0
  }
  if (m1.type === 'glyph') {
    const action = ['Any', 'Flexion', 'Extension', 'Abduction', 'Adduction', 'Still', 'CircleCW', 'CircleCCW', 'TriangleCW', 'TriangleCCW', 'SquareCW', 'SquareCCW', 'Zigzag']
    const i1 = action.indexOf(m1.action)
    const i2 = action.indexOf(m2.action)
    if (i1 !== i2) return (i1 > i2) ? 1 : -1

    if (m1.context.length !== m2.context.length) return m1.context.length > m2.context.length
    for (let i = 0; i < m1.context.length; i++) {
      if (m1.context[i] !== m2.context[i]) {
        return (m1.context[i] === 'Contact') ? 1 : -1
      }
    }
    if (!m1.actuator || !m2.actuator) {
      if (!m1.actuator && m2.actuator) return -1
      if (m1.actuator && !m2.actuator) return 1
    } else if (m1.actuator && !m2.actuator) {
      if (m1.actuator.actuators !== m2.actuator.actuators) return (m1.actuator.actuators.length > m2.actuator.actuators.length) ? 1 : -1
    }
    return 0
  } else if (['and', 'or', 'then'].includes(m1.type)) {
    if (m1.operands.length !== m2.operands.length) return (m1.operands.length > m2.operands.length) ? 1 : -1
    for (let i = 0; i < Math.min(m1.operands.length, m2.operands.length); i++) {
      const temp = sortMicrogeste(m1.operands[i], m2.operands[i])
      if (temp !== 0) return temp
    }
    return 0
  } else if (m1.type === 'seq') {
    return sortMicrogeste(m1.seq, m2.seq)
  }
  return 0
}

function isMicrogestePseudoEqual (m1, m2) {
  if (m1.type !== 'glyph' && m2.type !== 'glyph') return 0
  if (m2.context.length > 0) {
    if (m1.context.length !== m2.context.length) return 0
    for (let i = 0; i < m1.context.length; i++) {
      if (m1.context[i] !== Context.Any && m2.context[i] !== Context.Any && m1.context[i] !== m2.context[i]) {
        return 0
      }
    }
  }
  if (m1.action !== Action.Any && m2.action !== Action.Any && m1.action !== m2.action) return 0
  if (m2.actuator && m2.actuator.length) {
    let isOk = false
    for (const x of m1.actuator) {
      for (const y of m2.actuator) {
        if (x.length === y.length) {
          let isSame = true
          for (let i = 0; i < x.length; i++) {
            if (x[i] !== y[i]) {
              isSame = false
            }
          }
          if (isSame) isOk = true
        }
      }
      if (m2.actuator.includes(x)) {
        isOk = true
      }
    }
    if (!isOk) return 0
  }
  if (m2.bottom && m1.bottom !== m2.bottom) return 0
  if (m2.phalanx && m2.phalanx.length) {
    let isOk = false
    for (const x of m1.phalanx) {
      for (const y of m2.phalanx) {
        if (x.length === y.length) {
          let isSame = true
          for (let i = 0; i < x.length; i++) {
            if (x[i] !== y[i]) {
              isSame = false
            }
          }
          if (isSame) isOk = true
        }
      }
      if (m2.phalanx.includes(x)) {
        isOk = true
      }
    }
    if (!isOk) return 0
  }

  let s = 1
  if (m1.action === Action.Any || m2.action === Action.Any) s /= 1.2
  if (m1.context.includes(Context.Any) || m2.context.includes(Context.Any)) s /= 1.2
  if (m1.actuator && m1.actuator.length) s /= 1.1
  if (m1.bottom) s /= 1.1
  if (m1.phalanx && m1.phalanx.length) s /= 1.1
  return s
}

function isMicrogesteIn (m1, m2) {
  if (m2.type === 'in-construction') {
    return 1
  } else if (m1.type === 'glyph') {
    if (m2.type === 'glyph') {
      return isMicrogestePseudoEqual(m1, m2)
    } else {
      return 0
    }
  } else if (['and', 'or', 'then'].includes(m1.type)) {
    if (m1.type === m2.type && m1.operands.length >= m2.operands.length) { // test if equal
      let totS = 1
      for (let i = 0; i < m2.operands.length; i++) {
        totS *= isMicrogesteIn(m1.operands[i], m2.operands[i])
      }
      if (totS > 0) return totS
    }
    // test if contained
    let maxS = 0
    for (let i = 0; i < m1.operands.length; i++) {
      const s = isMicrogesteIn(m1.operands[i], m2)
      if (s > maxS) {
        maxS = s
      }
    }
    return maxS / 3
  } else if (m1.type === 'seq') {
    if (m2.type === 'seq') {
      return m1.quantificators === m2.quantificators && isMicrogesteIn(m1.seq, m2.seq)
    } else {
      return isMicrogesteIn(m1.seq, m2)
    }
  }
  return false
}

function searchMicrogeste (microgeste) {
  if (microgeste.type !== 'in-construction') {
    displayedMM.value = displayedMM.value
      .map(x => { x.score = isMicrogesteIn(x.µGlyphe, microgeste); return x })
      .filter(x => x.score > 0)
      .sort((x, y) => {
        if (x.score > y.score) return -1
        else if (x.score < y.score) return 1
        else return 0
      })
  }
}

function isInMGlyphTestActuator (value, actuator) {
  for (const x of actuator) {
    for (let i = 0; i < x.length; i++) {
      if (['thumb', 'index', 'middle', 'ring', 'pinky'].includes(value) && x[i] === value[0]) return true
      if (x[i] === value) return true
    }
  }
  return false
}

function isInMGlyphTestPhalanx (value, phalanx) {
  for (const x of phalanx) {
    for (let i = 0; i < x.length; i++) {
      if (['tip', 'middle', 'base', 'nail', 'left', 'right', 'front', 'back'].includes(value) && (x[i].segment === value[0] || x[i].side === value[0])) return true
      if (x[i].segment === value || x[i].side === value) return true
    }
  }
  return false
}

function isInMGlyph (value, m) {
  if (m.type === 'in-construction') {
    return false
  } else if (m.type === 'glyph') {
    if (m.context.map(x => x.toLowerCase()).includes(value)) return true
    if (m.action.toLowerCase() === value) return true
    if (m.actuator && isInMGlyphTestActuator(value, m.actuator)) return true
    if (m.phalanx && isInMGlyphTestPhalanx(value, m.phalanx)) return true

    if (m.contact) {
      if (m.contact.actuator && isInMGlyphTestActuator(value, m.contact.actuator)) return true
      if (m.contact.phalanx && isInMGlyphTestPhalanx(value, m.contact.phalanx)) return true
    }
    return false
  } else if (['and', 'or', 'then'].includes(m.type)) {
    let isIn = false
    for (let i = 0; i < m.operands.length; i++) {
      isIn = isIn || isInMGlyph(value, m.operands[i])
    }
    return isIn
  } else if (m.type === 'seq') {
    for (const q of m.quantificators.x) {
      if (isInMGlyphTestActuator(value, q)) return true
    }

    for (const q of m.quantificators.y) {
      if (isInMGlyphTestPhalanx(value, q)) return true
    }
    return isInMGlyph(value, m.seq)
  }
  return false
}

function search (e) {
  displayedMM.value = allMM.value.slice()
  for (const s of e) {
    if (s.type === 'microgeste') {
      searchMicrogeste(s.value)
    } else if (s.type === 'name') {
      displayedMM.value = displayedMM.value
        .filter(x => x.name.toLowerCase().includes(s.value.toLowerCase()))
    } else if (s.type === 'description') {
      displayedMM.value = displayedMM.value
        .filter(x => x.textDescription.toLowerCase().includes(s.value.toLowerCase()))
    } else if (s.type === 'doi') {
      displayedMM.value = displayedMM.value
        .filter(x => x.paper.doi.toLowerCase().includes(s.value.toLowerCase()))
    } else if (s.type === 'paper_title') {
      displayedMM.value = displayedMM.value
        .filter(x => x.paper.title.toLowerCase().includes(s.value.toLowerCase()))
    } else if (s.type === 'grasp') {
      if (['freehand', 'free-hand', 'free hand'].includes(s.value.toLowerCase())) {
        displayedMM.value = displayedMM.value
          .filter(x => {
            return (!x.grasp ||
                    !x.grasp.length) &&
                   (!x.customGrasp ||
                    !x.customGrasp.split(',').length)
          })
      } else {
        displayedMM.value = displayedMM.value
          .filter(x => {
            return (x.grasp &&
                    x.grasp
                      .map(x => x.toLowerCase())
                      .includes(s.value.toLowerCase())) ||
                   (x.customGrasp &&
                    x.customGrasp
                      .toLowerCase()
                      .split(',')
                      .includes(s.value.toLowerCase()))
          })
      }
    } else if (s.type === 'object') {
      displayedMM.value = displayedMM.value
        .filter(x => x.object && x.object.toLowerCase().includes(s.value.toLowerCase()))
    } else if (s.type === 'mglyph') {
      displayedMM.value = displayedMM.value
        .filter(x => isInMGlyph(s.value, x.µGlyphe))
    }
  }
  reloadTable.value++
}

function resetSearch () {
  displayedMM.value = allMM.value.slice().sort((x, y) => {
    if (x.name > y.name) {
      return 1
    }
    if (x.name < y.name) {
      return -1
    }
    return 0
  })
  reloadTable.value++
}

onMounted(() => {
  axios.get('/api/literature')
    .then((d) => {
      for (const lit of d.data) {
        if (lit.mmList) {
          allMM.value.push(...lit.mmList.map(x => {
            return { ...x, paper: lit }
          }))
        }
      }
      displayedMM.value = allMM.value.slice()
      displayedMM.value.sort((x, y) => {
        if (x.name > y.name) {
          return 1
        }
        if (x.name < y.name) {
          return -1
        }
        return 0
      })
    })
    .catch(err => console.log(err))
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_unref(SearchBar), {
      microgesteSearchValue: microgesteSearchValue.value,
      onSearch: search,
      onReset: resetSearch
    }, null, 8, ["microgesteSearchValue"]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedMM.value.entries(), ([index, row]) => {
        return (_openBlock(), _createBlock(_unref(MicroRow), {
          key: `${index}-${reloadTable.value}`,
          paper: row.paper,
          microgesture: row
        }, null, 8, ["paper", "microgesture"]))
      }), 128))
    ])
  ]))
}
}

}